import React from 'react'
import EmployeeLoginComp from '../../../components/Employee/auth/login'

export default function EmployeeLogin() {
  return (
    <EmployeeLoginComp />
  )
}